import React from 'react';
import { featureCards, solutionSlides, solutionStats, studioUrl } from '../data/siteData';
import Reveal from '../components/Reveal';
import SectionHeader from '../components/SectionHeader';
import SolutionCarousel from '../components/SolutionCarousel';
import AppLink from '../components/AppLink';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <SolutionCarousel stats={solutionStats} slides={solutionSlides} />
      <CtaSection />
    </>
  );
}

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-grid-pattern" />
      <div className="container hero-inner">
        <div className="hero-copy">
          <Reveal as="h1" variant="fade-up" duration={900} threshold={0.2} distance={34}>
            Bem-vindo ao <span>EtiquetandoApp</span>
          </Reveal>
          <Reveal as="p" variant="fade-up" duration={880} threshold={0.2} distance={30} delay={140}>
            Solução para impressão de etiqueta de volumes, seja para transportadoras, setores logísticos, comércio em geral.
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  return (
    <section id="features" className="features-section">
      <div className="container">
        <SectionHeader title="Por que escolher o EtiquetandoApp?" />

        <div className="feature-grid">
          {featureCards.map((card, index) => (
            <Reveal
              key={card.title}
              delay={index * 90}
              className="feature-card"
              variant="fade-up-scale"
              duration={600}
              threshold={0.2}
              distance={50}
              scaleFrom={0.9}
            >
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function CtaSection() {
  return (
    <section id="cta" className="cta-section">
      <div className="cta-pattern" />
      <div className="cta-orb cta-orb--left" />
      <div className="cta-orb cta-orb--right" />

      <div className="container cta-inner">
        <div className="cta-copy">
          <Reveal as="h2" variant="fade-up" duration={820} threshold={0.2} distance={34}>
            Pronto para revolucionar sua logística?
          </Reveal>
          <Reveal as="p" variant="fade-up" duration={820} threshold={0.2} distance={30} delay={120}>
            Experimente o EtiquetandoApp e veja como podemos otimizar seu processo de etiquetagem.
          </Reveal>
          <Reveal
            as="div"
            className="cta-actions"
            variant="fade-up"
            duration={820}
            threshold={0.2}
            distance={36}
            delay={220}
          >
            <AppLink href={studioUrl} className="button button--blue">
              Abrir Studio
            </AppLink>
            <AppLink href="/downloads" className="button button--light">
              Ver downloads
            </AppLink>
            <a href="https://wa.me/5547997026699" target="_blank" rel="noreferrer" className="button button--ghost">
              Falar no WhatsApp
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
